import React, { Component } from 'react';
import './../../css/table.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faDownload } from '@fortawesome/free-solid-svg-icons';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'jalali-moment';

const MySwal = withReactContent(Swal);

export default class JobResume extends Component {
  constructor(props) {
    super(props);

    this.state = {
      posts: [],
    };
  }
  componentDidMount() {
    this.getPost();
  }

  downloadResume(resume_id) {
    window.location.href = `https://arianapars-dashboard.ap-immigration.ir/app/resume-download/${resume_id}`;
  }

  seenResume(id) {
    console.log(id)
    axios
      .post(
        'https://arianaapp.arianaapply.com/panel/change-flag-for-new-resumejobopportunity',
        {
          id,
        }
      )
      .then((res) => {
        console.log(res);
        MySwal.fire({
          title: 'با موفقیت ثبت شد',
          icon: 'success',
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload(false);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  render() {
    return (
      <div className='index'>
        {this.state.posts.length > 0 ? (
          <div className='table'>
            <table>
              <thead>
                <tr>
                  <td>نام</td>
                  <td>شهر</td>
                  <td>ایمیل</td>
                  <td>جنسیت</td>
                  <td>زبان</td>
                  <td>سن</td>
                  <td>تاهل</td>
                  <td>خدمت</td>
                  <td>شماره تماس</td>
                  <td>تاریخ</td>
                  <td>جزئیات</td>
                </tr>
              </thead>
              <tbody>
                {this.state.posts.reverse().map((item) => (
                  <tr key={item._id}>
                    <td>{item.resume.name}</td>
                    <td>{item.resume.city}</td>
                    <td>{item.resume.email}</td>
                    <td>{item.resume.gender}</td>
                    <td>{item.resume.language}</td>
                    <td>{item.resume.age}</td>
                    <td>{item.resume.maritalStatus}</td>
                    <td>{item.resume.militaryService}</td>
                    <td>{item.resume.phone}</td>
                    <td>
                      {
                        moment(item.created_at, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('YYYY/MM/DD')
                      }
                    </td>
                    <td
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}>
                      <button
                        className='info'
                        onClick={() => this.downloadResume(item.resume._id)}>
                        <FontAwesomeIcon icon={faDownload} />
                      </button>
                      <button
                        className='success'
                        onClick={() => this.seenResume(item.resume._id)}>
                        <FontAwesomeIcon icon={faEye} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          'رزومه ای وجود ندارد'
        )}
      </div>
    );
  }

  getPost() {
    axios
      .get(
        `https://arianaapp.arianaapply.com/panel/check-resume/${this.props.match.params.id}`
      )
      .then((response) => {
        this.setState({ posts: response.data });
        console.log(response);
      })
      .catch((err) => {
        console.log(err);
        MySwal.fire({
          title: 'دوباره امتحان کنید',
          icon: 'error',
        });
      });
  }
}
